// i18next-extract-mark-ns-start inspirations
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import CTALink from '../../CTALink';
import { colors } from '../v4/styledComponents';
import { inspirationsImages, getInspirationsInfos } from './inspirationsData';

// couture
import sofa from '../../../assets/ourServices/couturier/sofa.mobile.inspirations.jpg';
import besace from '../../../assets/ourServices/couturier/besace.mobile.inspirations.jpg';
import coudière from '../../../assets/ourServices/couturier/coudiere.mobile.inspirations.jpg';

// maroquinerie
import ceinture1 from '../../../assets/ourServices/leatherGoods/ceinture.mobile.inspirations.jpg';
import sac1 from '../../../assets/ourServices/leatherGoods/sac.mobile.inspirations.jpg';
import petiteMaro1 from '../../../assets/ourServices/leatherGoods/petiteMaro.mobile.inspirations.jpg';

// broderie
import broderie2 from '../../../assets/ourServices/embroidery/broderie2.mobile.inspirations.jpg';
import broderie8 from '../../../assets/ourServices/embroidery/broderie8.mobile.inspirations.jpg';
import broderie11 from '../../../assets/ourServices/embroidery/broderie11.mobile.inspirations.jpg';

import calendarIcon from '../../../assets/ourServices/calendar.svg';

const Container = styled.div`
  margin: 0;
`;

const ImageBlockContainer = styled.div`
`;

const Img = styled.img`
  height: 288px;
  border-radius: 12px;
`;

const MobileBlock = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: scroll;
`;

const BlockContainer = styled.div`
  position: absolute;
  padding: 12px 15px;
  background-color: ${colors.beige100};
  color: ${colors.black};
  border-radius: 4px;
  bottom: 12px;
  left: ${(props) => props.adjustLeft ? '22%' : '50%'};
  transform: translate(-50%, 0%);
  width: 145px;
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
`;

const BlockContainerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Subtitle = styled.p`
  font-size: 10px;
  font-family: 'Space Mono', monospace;
  text-transform: uppercase;
  margin: 0;
`;

const Price = styled.span`
  font-size: 6px;
`;

const Text = styled.p`
  font-size: 6px;
  color: ${colors.grey600};
  max-width: 134px;
  margin: 0;
`;

const Calendar = styled.img`
  height: 13px;
`;

function InspirationsMobile({ range }) {
  const { t } = useTranslation();
  const inspirationsInfos = getInspirationsInfos(true, t);
  const inspirationsData = inspirationsInfos[range];

  return (
    <Container>
      <MobileBlock>
        {inspirationsImages[range].mobileImages.map((image, index) => (
          <ImageBlockContainer key={image.toString()}>
            <BlockContainerWrapper>
              <Img src={image} alt={range} />
              <CTALink fromInteraction="Inspirations" linkState={inspirationsData[index].preFilledSteps}>
                <BlockContainer
                  adjustLeft={[sofa, coudière, besace, sac1, ceinture1, petiteMaro1, broderie2, broderie8, broderie11].includes(inspirationsImages[range].mobileImages[index])}
                >
                  <Block>
                    <Subtitle>{inspirationsData[index].title}</Subtitle>
                    <Price>{inspirationsData[index].price}</Price>
                    <Text>{inspirationsData[index].text}</Text>
                    <Calendar src={calendarIcon} alt={t('icône calendrier')} />
                  </Block>
                </BlockContainer>
              </CTALink>
            </BlockContainerWrapper>
          </ImageBlockContainer>
        ))}
      </MobileBlock>
    </Container>
  );
}

InspirationsMobile.propTypes = {
  range: PropTypes.string.isRequired,
};

export default InspirationsMobile;
